<template>
  <v-form
    ref="editUserForm"
    v-model="isFormValid"
    class="edit-user"
    @submit.prevent="submitForm"
  >
    <label class="input-label">Adres e-mail konta:</label>
    <v-text-field
      :value="user.email"
      v-bind="props.validatedField"
      readonly
    />

    <label class="input-label">Tytuł</label>
    <v-text-field
      v-model="editingUser.title"
      v-bind="props.validatedField"
      :rules="[rules.required]"
      placeholder="Wprowadź tytuł"
    />

    <label class="input-label">Uprawnienia</label>
    <v-select
      v-model="editingUser.roleIds"
      placeholder="Wybierz role użytkownika"
      v-bind="props.validatedField"
      :rules="[rules.required]"
      :items="filtersOptions.roles"
      item-text="label"
      item-value="id"
      :menu-props="{ 'offset-y': true }"
      multiple
    >
      <template #selection="{ item, index }">
        <template v-if="index < 2">
          <span
            v-if="index > 0"
            class="mr-1"
          >,</span>

          <span
            :class="[
              'overflow-ellipsis',
              editingUser.roleIds.length > 1 ? 'max-width-160' : 'max-width-full'
            ]"
          >
            {{ item.label }}
          </span>
        </template>

        <span
          v-if="index === 2"
          class="ml-1"
        >(+{{ editingUser.roleIds.length - 2 }})</span>
      </template>
    </v-select>

    <label class="input-label">Departament</label>
    <v-autocomplete
      v-model="editingUser.departmentId"
      placeholder="Wybierz departament"
      v-bind="props.validatedField"
      :rules="[rules.required]"
      :items="filtersOptions.departments"
      item-text="name"
      item-value="id"
      :menu-props="{ 'offset-y': true }"
    />

    <v-btn
      class="custom-submit-button mt-4"
      color="primary"
      type="submit"
    >
      Zapisz
    </v-btn>
  </v-form>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import props from '@/helpers/componentsProps';
import rules from '@/helpers/validators';

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      props,
      rules,
      editingUser: {
        id: null,
        roleIds: [],
        departmentId: null,
        title: '',
      },
      isFormValid: null,
    };
  },

  computed: {
    ...mapState('filters', [
      'filtersOptions',
    ]),
  },

  created() {
    const {
      title, departmentId, roles, id,
    } = this.user;

    this.editingUser = {
      id,
      title,
      departmentId: departmentId,
      roleIds: roles.map((r) => r.id),
    };
  },

  methods: {
    ...mapActions('users', [
      'editUserRole',
    ]),

    submitForm() {
      this.$refs.editUserForm.validate();

      if (this.isFormValid) {
        this.editUserRole(this.editingUser);
      }
    },
  },

};
</script>
